import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface CardTerminalException {
  id: string;
  reconciliationDate: string;
  kind:
    | 'provider_unrecorded'
    | 'ledger_missing'
    | 'ledger_refunded'
    | 'ledger_charged_back'
    | 'record_error'
    | 'manual_while_enabled'
    | 'transaction_mismatch';
  severity: 'error' | 'info';
  invoiceId: string | null;
  paymentId: string | null;
  transactionCode: string | null;
  amountCents: number;
  currency: string;
}

export function useCardTerminalReconciliation() {
  return useQuery({
    queryKey: ['card-terminal-reconciliation', 'exceptions'],
    queryFn: () =>
      api.get<{ exceptions: CardTerminalException[] }>('/card-terminal-reconciliation/exceptions'),
  });
}
